import { http } from '@/api/http'
import { toListParams, type ListQuery } from '@/api/query'
import type { WarehouseRegister, WarehouseRegisterFileType } from '@/types/api'
import type { RequestOptions } from '../crud'

export type WarehouseRegisterInput = {
  warehouse_id: string
  from_date: string
  to_date: string
  items: { id?: string; type: WarehouseRegisterFileType; file: string }[]
}

type RegisterPage = { items: WarehouseRegister[] | null; count: number }

const base = '/warehouse/admin-registers'

/** The admin «Реестр»: registers of every warehouse in the granted branches; there is no delete. */
export const warehouseRegistersService = {
  path: 'warehouse/admin-registers',
  async list(query?: ListQuery, options?: RequestOptions) {
    const { data } = await http.get<RegisterPage>(base, { params: toListParams({ page: query?.page, limit: query?.limit }), ...options })
    return { count: data.count ?? 0, items: data.items ?? [] }
  },
  async get(id: string, options?: RequestOptions) {
    const { data } = await http.get<WarehouseRegister>(`${base}/${encodeURIComponent(id)}`, options)
    return data
  },
  async create(body: WarehouseRegisterInput) {
    const { data } = await http.post<WarehouseRegister>(base, body)
    return data
  },
  async update(id: string, body: WarehouseRegisterInput) {
    const { data } = await http.put<WarehouseRegister>(`${base}/${encodeURIComponent(id)}`, body)
    return data
  },
}
